// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.
import { loginPageInfo } from "./Pages/Authentication/Login/pageinfo";
import { logoutPageInfo } from "./Pages/Authentication/Logout/pageinfo";
import { mfaLoginPageInfo } from "./Pages/Authentication/MFALogin/pageinfo";
import { recoverPageInfo } from "./Pages/Authentication/Recover/pageinfo";
import { setPasswordPageInfo } from "./Pages/Authentication/SetPassword/pageinfo";
import { financialsPageInfo } from "./Pages/Financials/pageinfo";
import { homePageInfo } from "./Pages/Home/pageinfo";
import { announcementHubDetailPageInfo } from "./Pages/Hubs/Announcements/DetailPage/pageinfo";
import { calendarEventHubDetailPageInfo } from "./Pages/Hubs/CalendarEvents/DetailPage/pageinfo";
import { newsletterHubDetailPageInfo } from "./Pages/Hubs/Newsletters/DetailPage/pageinfo";
import { postHubDetailPageInfo } from "./Pages/Hubs/Posts/DetailPage/pageinfo";
import { messagingCreatePageInfo } from "./Pages/Messaging/CreatePage/pageinfo";
import { messagingIndexPageInfo } from "./Pages/Messaging/IndexPage/pageinfo";
import { messagingMessageGroupPageInfo } from "./Pages/Messaging/MessageGroup/pageinfo";
import { messagingPageInfo } from "./Pages/Messaging/pageinfo";
import { modelDetailRedirectPageInfo } from "./Pages/ModelDetailRedirectPage/pageinfo";
import { onboardingPageInfo } from "./Pages/Onboarding/pageinfo";
import { preferencesIndexPageInfo } from "./Pages/Preferences/IndexPage/pageinfo";
import { preferencesPageInfo } from "./Pages/Preferences/pageinfo";
import { preferencesStudentDataConsentsPageInfo } from "./Pages/Preferences/StudentDataConsents/pageinfo";
import { reEnrollmentDataConsentPageInfo } from "./Pages/ReEnrollment/DataConsentPage/pageinfo";
import { reEnrollmentGuardiansDetailPageInfo } from "./Pages/ReEnrollment/GuardiansPage/DetailPage/pageinfo";
import { reEnrollmentGuardiansIndexPageInfo } from "./Pages/ReEnrollment/GuardiansPage/IndexPage/pageinfo";
import { reEnrollmentGuardiansPageInfo } from "./Pages/ReEnrollment/GuardiansPage/pageinfo";
import { reEnrollmentIndexPageInfo } from "./Pages/ReEnrollment/IndexPage/pageinfo";
import { reEnrollmentMealPlansPageInfo } from "./Pages/ReEnrollment/MealPlansPage/pageinfo";
import { reEnrollmentPageInfo } from "./Pages/ReEnrollment/pageinfo";
import { reEnrollmentPaymentPlansDefinitionSelectionPageInfo } from "./Pages/ReEnrollment/PaymentPlansPage/DefinitionSelectionPage/pageinfo";
import { reEnrollmentPaymentPlansGroupedPageInfo } from "./Pages/ReEnrollment/PaymentPlansPage/GroupedPage/pageinfo";
import { reEnrollmentPaymentPlansIndividualPageInfo } from "./Pages/ReEnrollment/PaymentPlansPage/IndividualPage/pageinfo";
import { reEnrollmentPaymentPlansPageInfo } from "./Pages/ReEnrollment/PaymentPlansPage/pageinfo";
import { reEnrollmentReviewPageInfo } from "./Pages/ReEnrollment/ReviewPage/pageinfo";
import { reEnrollmentStudentHealthDetailPageInfo } from "./Pages/ReEnrollment/StudentHealthPage/DetailPage/pageinfo";
import { reEnrollmentStudentHealthIndexPageInfo } from "./Pages/ReEnrollment/StudentHealthPage/IndexPage/pageinfo";
import { reEnrollmentStudentHealthPageInfo } from "./Pages/ReEnrollment/StudentHealthPage/pageinfo";
import { reEnrollmentSuccessPageInfo } from "./Pages/ReEnrollment/SuccessPage/pageinfo";
import { rootPageInfo } from "./root.pageinfo";

export const allPages = [
	loginPageInfo,
	logoutPageInfo,
	mfaLoginPageInfo,
	recoverPageInfo,
	setPasswordPageInfo,
	financialsPageInfo,
	homePageInfo,
	announcementHubDetailPageInfo,
	calendarEventHubDetailPageInfo,
	newsletterHubDetailPageInfo,
	postHubDetailPageInfo,
	messagingCreatePageInfo,
	messagingIndexPageInfo,
	messagingMessageGroupPageInfo,
	messagingPageInfo,
	modelDetailRedirectPageInfo,
	onboardingPageInfo,
	preferencesIndexPageInfo,
	preferencesStudentDataConsentsPageInfo,
	preferencesPageInfo,
	reEnrollmentDataConsentPageInfo,
	reEnrollmentGuardiansDetailPageInfo,
	reEnrollmentGuardiansIndexPageInfo,
	reEnrollmentGuardiansPageInfo,
	reEnrollmentIndexPageInfo,
	reEnrollmentMealPlansPageInfo,
	reEnrollmentPaymentPlansDefinitionSelectionPageInfo,
	reEnrollmentPaymentPlansGroupedPageInfo,
	reEnrollmentPaymentPlansIndividualPageInfo,
	reEnrollmentPaymentPlansPageInfo,
	reEnrollmentReviewPageInfo,
	reEnrollmentStudentHealthDetailPageInfo,
	reEnrollmentStudentHealthIndexPageInfo,
	reEnrollmentStudentHealthPageInfo,
	reEnrollmentSuccessPageInfo,
	reEnrollmentPageInfo,
	rootPageInfo,
];
